import { render } from "./patientappointment.vue?vue&type=template&id=89372992&scoped=true"
import script from "./patientappointment.vue?vue&type=script&lang=js"
export * from "./patientappointment.vue?vue&type=script&lang=js"

import "./patientappointment.vue?vue&type=style&index=0&id=89372992&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89372992"]])

export default __exports__